import styled from "styled-components"
import PropTypes from "prop-types"
import { color, width, space, alignItems, justifyContent } from "styled-system"

const buttonSize = ({ size }) => {
  switch (size) {
    case "medium":
      return `
        width: 155px;
        min-height: 46px;
        box-shadow: 0 1px 4px 0 rgba(0, 132, 137, 0.1),
        0 4px 12px 0 rgba(0, 132, 137, 0.15);
        &:hover {
          box-shadow: 0 12px 12px 0 rgba(43,62,81,0.10), 0 16px 32px 0 rgba(43,62,81,0.10);
        }
      `
    case "large":
      return `
      box-shadow: 0 1px 4px 0 rgba(0, 132, 137, 0.1), 0 4px 12px 0 rgba(0, 132, 137, 0.15);  
      min-height: 58px;
      width: 338px;
      &:hover {
        box-shadow: 0 12px 12px 0 rgba(43,62,81,0.10), 0 16px 32px 0 rgba(43,62,81,0.10);
       }
        `
    case "fluid":
      return `
        width: auto;
        min-height: 56px;
        padding-top: 12px;
        padding-bottom: 12px;
        box-shadow: 0 1px 4px 0 rgba(0, 132, 137, 0.1),
        0 4px 12px 0 rgba(0, 132, 137, 0.15);
        transition: all 0.2s ease-in-out;
        &:hover {
          box-shadow: 0 12px 12px 0 rgba(43,62,81,0.10), 0 16px 32px 0 rgba(43,62,81,0.10);
        }
        `
    default:
      return `
        width: 155px;
        height: 56px;
      `
  }
}

const buttonType = ({ type }) => {
  switch (type) {
    case "hero":
      return `
        transform: scale(1);
        &:hover {
          transform: scale(1.1);
        }
      `
    default:
      return `
        transform: scale(1);
        `
  }
}

const Button = styled.div`
  display: flex;
  border-radius: 4px;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  ${buttonSize};
  ${buttonType};
  ${color};
  ${width};
  ${space};
  ${alignItems};
  ${justifyContent};
`

Button.defaultProps = {
  size: "medium",
  bg: "white"
}

Button.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large", "fluid"]),
  type: PropTypes.oneOf(["hero"])
}

export default Button



// WEBPACK FOOTER //
// ./src/components/button/button.component.js